<!--
 * @description: 机制砂：编辑，查看
 * @Author: Roger Wei 
 * @Date: 2022-01-20 09:11:41 
 * @Last Modified by:   Roger Wei 
 * @Last Modified time: 2022-01-20 09:11:41 
 *
 --->
<template>
  <div id="template5" class="template_table_parent">
    <table v-if="formData" class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="11"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="4">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_02 }}</td>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_03 }}</td>
        <td>取样日期</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="4">{{ defaultData.cell_05 }}</td>
        <td>规 格</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_06 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg6: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="3">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="4">
          <span v-if="defaultData && defaultData.cell_09">{{ defaultData.cell_09 }}</span>
        </td>
        <td>产 地</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg6: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_07.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检验依据</td>
        <td :class="{ bg4: !isViewResult }" colspan="3">
          <el-input v-model="formData.cell_12.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="3">进场验收项目</td>
        <td rowspan="2">颜色对比</td>
        <td colspan="2">石粉含量（%）</td>
        <td rowspan="2" colspan="2">含泥量（天然砂）（%）</td>
        <td rowspan="2" colspan="2">泥块含量</td>
        <td rowspan="2">细度模数（uf）</td>
        <td rowspan="2" colspan="2">颗粒级配</td>
        <td rowspan="2" colspan="2">含石量（%）</td>
        <td rowspan="2" colspan="2">含水率（%）</td>
      </tr>
      <tr>
        <td>MB值＜1.4</td>
        <td>MB值≥1.4</td>
      </tr>
      <tr>
        <td :class="{ bg5: !isViewResult }">
          <el-select v-model="formData.cell_13.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_13.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td :class="[!isViewResult? bg5: formData.cell_14.clsObj]"><el-input v-model="formData.cell_14.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td :class="[!isViewResult? bg5: formData.cell_15.clsObj]"><el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td :class="[!isViewResult? bg5: formData.cell_16.clsObj]" colspan="2"><el-input v-model="formData.cell_16.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <el-select v-model="formData.cell_17.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_17.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td :class="[!isViewResult? bg5: formData.cell_18.clsObj]"><el-input v-model="formData.cell_18.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <el-select v-model="formData.cell_19.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_19.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td :class="[!isViewResult? bg5: formData.cell_20.clsObj]" colspan="2"><el-input v-model="formData.cell_20.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td :class="[!isViewResult? bg5: formData.cell_21.clsObj]" colspan="2"><el-input v-model="formData.cell_21.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
      </tr>
      <tr>
        <td colspan="2">试样重量（g）</td>
        <td class="4">
          <el-input v-model="formData.cell_22.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="3">10mm筛筛余量（g）</td>
        <td class="2" colspan="2">
          <el-input v-model="formData.cell_23.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="3">10mm以上粒径含量（%）</td>
        <td colspan="4">{{ formData.cell_24.resultValue }}</td>
      </tr>
      <tr>
        <td rowspan="4">堆积密度</td>
        <td rowspan="2">（样+筒）（g）</td>
        <td rowspan="2">筒重（g）</td>
        <td rowspan="2">筒容积（L）</td>
        <td rowspan="2">密度值（kg/m³）</td>
        <td rowspan="2">平均值（kg/m³）</td>
        <td rowspan="2">试验用量</td>
        <td rowspan="2" colspan="3">第一次样重=500g</td>
        <td rowspan="2" colspan="3">第er次样重=500g</td>
        <td rowspan="5">分计筛余百分率平均值（%）</td>
        <td rowspan="5">累计筛余百分率平均值（%）</td>
      </tr>
      <tr></tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_25.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_26.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_27.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_28.resultValue }}</td>
        <td :class="{ bg1: !isViewResult }" rowspan="2">{{ formData.cell_33.resultValue }}</td>
        <td rowspan="3">筛孔尺寸</td>
        <td rowspan="3">分计筛余量（g）</td>
        <td rowspan="3">分计筛余百分率（%）</td>
        <td rowspan="3">累计筛余百分率（%）</td>
        <td rowspan="3">分计筛余量（g）</td>
        <td rowspan="3">分计筛余百分率（%）</td>
        <td rowspan="3">累计筛余百分率（%）</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_29.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_30.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_31.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_32.resultValue }}</td>
      </tr>
      <tr>
        <td rowspan="4">表观密度</td>
        <td rowspan="2">样重（g）</td>
        <td rowspan="2">（瓶+水）（g）</td>
        <td rowspan="2">（样+瓶+水）（g）</td>
        <td rowspan="2">密度值（kg/m³）</td>
        <td rowspan="2">平均值（kg/m³）</td>
      </tr>
      <tr>
        <td>9.50mm</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_63.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_64 ? formData.cell_64.resultValue: 0 }}</td>
        <td>{{ formData.cell_65 ? formData.cell_65.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_66.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_67 ? formData.cell_67.resultValue: 0 }}</td>
        <td>{{ formData.cell_68 ? formData.cell_68.resultValue: 0 }}</td>
        <td>{{ formData.cell_69 ? formData.cell_69.resultValue: 0 }}</td>
        <td>{{ formData.cell_70 ? formData.cell_70.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_34.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_35.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_36.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_37.resultValue }}</td>
        <td :class="{ bg1: !isViewResult }" rowspan="2">{{ formData.cell_42.resultValue }}</td>
        <td>4.75mm</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_71.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_72 ? formData.cell_72.resultValue: 0 }}</td>
        <td>{{ formData.cell_73 ? formData.cell_73.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_74.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_75 ? formData.cell_75.resultValue: 0 }}</td>
        <td>{{ formData.cell_76 ? formData.cell_76.resultValue: 0 }}</td>
        <td>{{ formData.cell_77 ? formData.cell_77.resultValue: 0 }}</td>
        <td>{{ formData.cell_78 ? formData.cell_78.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_38.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_39.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_40.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_41.resultValue }}</td>
        <td>2.36mm</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_79.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_80 ? formData.cell_80.resultValue: 0 }}</td>
        <td>{{ formData.cell_81 ? formData.cell_81.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_82.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_83 ? formData.cell_83.resultValue: 0 }}</td>
        <td>{{ formData.cell_84 ? formData.cell_84.resultValue: 0 }}</td>
        <td>{{ formData.cell_85 ? formData.cell_85.resultValue: 0 }}</td>
        <td>{{ formData.cell_86 ? formData.cell_86.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td>空隙率（%）</td>
        <td colspan="5">{{ formData.cell_136.resultValue }}</td>
        <td>1.18mm</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_87.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_88 ? formData.cell_88.resultValue: 0 }}</td>
        <td>{{ formData.cell_89 ? formData.cell_89.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_90.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_91 ? formData.cell_91.resultValue: 0 }}</td>
        <td>{{ formData.cell_92 ? formData.cell_92.resultValue: 0 }}</td>
        <td>{{ formData.cell_93 ? formData.cell_93.resultValue: 0 }}</td>
        <td>{{ formData.cell_94 ? formData.cell_94.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td rowspan="4">石粉含量</td>
        <td rowspan="2">洗前干重（g）</td>
        <td rowspan="2">洗后干重（g）</td>
        <td rowspan="2">含泥量（%）</td>
        <td colspan="2" rowspan="2">平均值（%）</td>
        <td>600um</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_95.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_96 ? formData.cell_96.resultValue: 0 }}</td>
        <td>{{ formData.cell_97 ? formData.cell_97.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_98.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_99 ? formData.cell_99.resultValue: 0 }}</td>
        <td>{{ formData.cell_100 ? formData.cell_100.resultValue: 0 }}</td>
        <td>{{ formData.cell_101 ? formData.cell_101.resultValue: 0 }}</td>
        <td>{{ formData.cell_102 ? formData.cell_102.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td>300um</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_103.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_104 ? formData.cell_104.resultValue: 0 }}</td>
        <td>{{ formData.cell_105 ? formData.cell_105.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_106.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_107 ? formData.cell_107.resultValue: 0 }}</td>
        <td>{{ formData.cell_108 ? formData.cell_108.resultValue: 0 }}</td>
        <td>{{ formData.cell_109 ? formData.cell_109.resultValue: 0 }}</td>
        <td>{{ formData.cell_110 ? formData.cell_110.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_43.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_44.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_45.resultValue }}</td>
        <td :class="{ bg1: !isViewResult }" colspan="2" rowspan="2">{{ formData.cell_49.resultValue }}</td>
        <td>150um</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_111.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_112 ? formData.cell_112.resultValue: 0 }}</td>
        <td>{{ formData.cell_113 ? formData.cell_113.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_114.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_115 ? formData.cell_115.resultValue: 0 }}</td>
        <td>{{ formData.cell_116 ? formData.cell_116.resultValue: 0 }}</td>
        <td>{{ formData.cell_117 ? formData.cell_117.resultValue: 0 }}</td>
        <td>{{ formData.cell_118 ? formData.cell_118.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_46.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_47.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_48.resultValue }}</td>
        <td>底</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_119.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_120 ? formData.cell_120.resultValue: 0 }}</td>
        <td>{{ formData.cell_121 ? formData.cell_121.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_122.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>{{ formData.cell_123 ? formData.cell_123.resultValue: 0 }}</td>
        <td>{{ formData.cell_124 ? formData.cell_124.resultValue: 0 }}</td>
        <td>{{ formData.cell_125 ? formData.cell_125.resultValue: 0 }}</td>
        <td>{{ formData.cell_126 ? formData.cell_126.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td rowspan="3">泥块含量</td>
        <td>洗前干重（g）</td>
        <td>洗后干重（g）</td>
        <td>泥块含量（%）</td>
        <td colspan="2">平均值（%）</td>
        <td rowspan="4">细度模数（uf）</td>
        <td>uf1=</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">{{ formData.cell_127 ? formData.cell_127.resultValue: 0 }}</td>
        <td colspan="2" rowspan="2">细度模数平均值（uf）</td>
        <td :class="{ bg1: !isViewResult }" colspan="3" rowspan="2">{{ formData.cell_129 ? formData.cell_129.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_50.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_51.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_52.resultValue }}</td>
        <td :class="{ bg1: !isViewResult }" colspan="2" rowspan="2">{{ formData.cell_56.resultValue }}</td>
        <td>uf2=</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">{{ formData.cell_128 ? formData.cell_128.resultValue: 0 }}</td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_53.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_54.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }">{{ formData.cell_55.resultValue }}</td>
        <td rowspan="2">uf1-uf2=</td>
        <td rowspan="2" colspan="2">{{ formData.cell_130.resultValue }}</td>
        <td rowspan="2">含石量（%）</td>
        <td>第一次</td>
        <td>第二次</td>
        <td colspan="2">平均值</td>
      </tr>
      <tr>
        <td rowspan="2">亚甲蓝试验</td>
        <td>样重（g）</td>
        <td colspan="2">亚甲蓝溶液（ml）</td>
        <td colspan="2">测定值</td>
        <td :class="{ bg3: !isViewResult }">{{ formData.cell_131 ? formData.cell_131.resultValue: 0 }}</td>
        <td :class="{ bg3: !isViewResult }">{{ formData.cell_132 ? formData.cell_132.resultValue: 0 }}</td>
        <td :class="{ bg1: !isViewResult }" colspan="2">{{ formData.cell_133.resultValue }}</td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_57.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_58.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_59.clsObj" colspan="2">{{ formData.cell_59.resultValue }}</td>
        <td rowspan="2">级配判定</td>
        <td :class="{ bg1: !isViewResult }" colspan="2" rowspan="2">
          <!-- <el-select v-model="formData.cell_134.resultValue"  placeholder="请选择">
                        
                        formData.cell_134.options
                        <el-option :value="0" label="合格"></el-option>
                        <el-option :value="1" label="不合格"></el-option>
                    </el-select> -->
          <el-select v-model="formData.cell_134.resultValue" disabled value-key="id">
            <el-option v-for="item in formData.cell_134.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td rowspan="2">备 注</td>
        <td colspan="5" rowspan="2">
          <el-input v-model="formData.cell_135.resultValue" type="textarea" :rows="2" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td colspan="2">总压碎值指标（%）</td>
        <td :class="{ bg6: !isViewResult }" colspan="4" @click="setData()">{{ formData.cell_60_p04.resultValue || "请配置" }}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">{{ user.approver.label }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">
          {{ user.inspector.label }}
        </td>
        <td></td>
        <td></td>
      </tr>
    </table>
    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @formChange="changeFun" @updated="updated" />
  </div>
</template>
<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"
//  'cell_07': { key: 'hjwd', title: '环境温度', category: 3, type: 3},
const dataArr = {
  cell_07: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3 },
  cell_08: { resultValue: "", key: "syrq", title: "实验日期", category: 3, type: 3 },
  cell_11: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3 },
  cell_12: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },
  cell_13: {
    key: "kjysdb",
    title: "颜色对比",
    category: 7,
    type: 1,
    resultValue: null,
    verify: "请配置颜色对比",
    options: [
      { id: 0, label: "相邻批次一致" },
      { id: 1, label: "相邻批次不一致" },
    ],
  },
  cell_14: { key: "kjsfhllt", title: "石粉含量", category: 7, type: 2, resultValue: "", verify: "请配置石粉含量" },
  cell_15: { key: "kjsfhlgt", title: "石粉含量", category: 7, type: 2, resultValue: "", verify: "请配置石粉含量" },
  cell_16: { key: "kjhnl", title: "含泥量", category: 7, type: 2, resultValue: "", verify: "请配置含泥量" },
  cell_17: {
    key: "kjnkhl",
    title: "泥块含量",
    category: 7,
    type: 1,
    resultValue: null,
    verify: "请配置泥块含量",
    options: [
      { id: 0, label: "目测无" },
      { id: 1, label: "目测有" },
    ],
  },
  cell_18: { key: "kjxdms", title: "细度模数", category: 7, type: 2, resultValue: "", verify: "请配置细度模数" },
  cell_19: {
    key: "kjkljp",
    title: "颗粒级配",
    category: 7,
    type: 1,
    resultValue: null,
    verify: "请配置颗粒级配",
    options: [
      { id: 0, label: "合格" },
      { id: 1, label: "不合格" },
    ],
  },
  cell_20: { key: "kjhshil", title: "含石量", category: 7, type: 2, resultValue: "", verify: "请配置含石量" },
  cell_21: { key: "kjhshuil", title: "含水率", category: 7, type: 2, resultValue: "", verify: "请配置含水率" },
  cell_22: { default: "2000", resultValue: "", key: "syzl", title: "试样重量", category: 6, type: 3 },
  cell_23: { resultValue: "", key: "syyl10", title: "10.0mm筛余余量", category: 6, type: 3 },
  cell_25: { resultValue: "", key: "djmdyt1", title: "堆积密度（样+筒）", category: 6, type: 3 },
  cell_26: { resultValue: "", key: "djmdtz1", title: "堆积密度（筒重）", category: 6, type: 3 },
  cell_27: { resultValue: "", key: "djmdtrj1", title: "堆积密度（筒容积）", category: 6, type: 3 },
  cell_29: { resultValue: "", key: "djmdyt2", title: "堆积密度（样+筒）", category: 6, type: 3 },
  cell_30: { resultValue: "", key: "djmdtz2", title: "堆积密度（筒重）", category: 6, type: 3 },
  cell_31: { resultValue: "", key: "djmdtrj2", title: "堆积密度（筒容积）", category: 6, type: 3 },
  cell_34: { resultValue: "", key: "bgmdyz1", title: "表观密度（样重）", category: 6, type: 3 },
  cell_35: { resultValue: "", key: "bgmdps1", title: "表观密度（瓶+水）", category: 6, type: 3 },
  cell_36: { resultValue: "", key: "bgmdyps1", title: "表观密度（样+瓶+水）", category: 6, type: 3 },
  cell_38: { resultValue: "", key: "bgmdyz2", title: "表观密度（样重）", category: 6, type: 3 },
  cell_39: { resultValue: "", key: "bgmdps2", title: "表观密度（瓶+水）", category: 6, type: 3 },
  cell_40: { resultValue: "", key: "bgmdyps2", title: "表观密度（样+瓶+水）", category: 6, type: 3 },
  cell_43: { resultValue: "", key: "hnlxqgz1", title: "含泥量（洗前干重）", category: 6, type: 3 },
  cell_44: { resultValue: "", key: "hnlxhgz1", title: "含泥量（洗后干重）", category: 6, type: 3 },
  cell_46: { resultValue: "", key: "hnlxqgz2", title: "含泥量（洗前干重）", category: 6, type: 3 },
  cell_47: { resultValue: "", key: "hnlxhgz2", title: "含泥量（洗后干重）", category: 6, type: 3 },
  cell_50: { resultValue: "", key: "nkhlxqgz1", title: "泥块含量（洗前干重）", category: 6, type: 3 },
  cell_51: { resultValue: "", key: "nkhlxhgz1", title: "泥块含量（洗后干重）", category: 6, type: 3 },
  cell_53: { resultValue: "", key: "nkhlxqgz2", title: "泥块含量（洗前干重）", category: 6, type: 3 },
  cell_54: { resultValue: "", key: "nkhlxhgz2", title: "泥块含量（洗后干重）", category: 6, type: 3 },
  cell_63: { resultValue: "", key: "fjsy1_1", title: "分计筛余量", category: 6, type: 3 },
  cell_71: { resultValue: "", key: "fjsy1_2", title: "分计筛余量", category: 6, type: 3 },
  cell_79: { resultValue: "", key: "fjsy1_3", title: "分计筛余量", category: 6, type: 3 },
  cell_87: { resultValue: "", key: "fjsy1_4", title: "分计筛余量", category: 6, type: 3 },
  cell_95: { resultValue: "", key: "fjsy1_5", title: "分计筛余量", category: 6, type: 3 },
  cell_103: { resultValue: "", key: "fjsy1_6", title: "分计筛余量", category: 6, type: 3 },
  cell_111: { resultValue: "", key: "fjsy1_7", title: "分计筛余量", category: 6, type: 3 },
  cell_119: { resultValue: "", key: "fjsy1_8", title: "分计筛余量", category: 6, type: 3 },
  cell_66: { resultValue: "", key: "fjsy2_1", title: "分计筛余量", category: 6, type: 3 },
  cell_74: { resultValue: "", key: "fjsy2_2", title: "分计筛余量", category: 6, type: 3 },
  cell_82: { resultValue: "", key: "fjsy2_3", title: "分计筛余量", category: 6, type: 3 },
  cell_90: { resultValue: "", key: "fjsy2_4", title: "分计筛余量", category: 6, type: 3 },
  cell_98: { resultValue: "", key: "fjsy2_5", title: "分计筛余量", category: 6, type: 3 },
  cell_106: { resultValue: "", key: "fjsy2_6", title: "分计筛余量", category: 6, type: 3 },
  cell_114: { resultValue: "", key: "fjsy2_7", title: "分计筛余量", category: 6, type: 3 },
  cell_122: { resultValue: "", key: "fjsy2_8", title: "分计筛余量", category: 6, type: 3 },
  cell_57: { resultValue: "", key: "yjlsyyz", title: "亚甲蓝试验（样重）", category: 6, type: 3 },
  cell_58: { resultValue: "", key: "yjlry", title: "亚甲蓝溶液", category: 6, type: 3 },
  cell_134: {
    resultValue: null,
    key: "jppd",
    options: [
      { id: 0, label: "合格" },
      { id: 1, label: "不合格" },
    ],
    title: "级配判定",
    category: 1,
    type: 3,
  },
  cell_135: { resultValue: "", key: "bz", title: "备注", category: 6, type: 3 },
  cell_60_p01: { unit: "g", valType: "input", resultValue: "1000", key: "yszzbsyz1", title: "试样重", category: 6, type: 3 },
  cell_60_p02: { unit: "g", valType: "input", resultValue: "", key: "yszzbzl1", title: "压碎后的筛余质量", category: 6, type: 3 },
  cell_60_p03: { unit: "g", valType: "calc", resultValue: "", key: "yszb1", title: "压碎指标", category: 6, type: 3 },
  cell_60_p04: { unit: "g", valType: "calc", resultValue: "", key: "zyszzb", title: "总压碎值指标", category: 6, type: 3 },
  cell_60_p05: { unit: "g", valType: "input", resultValue: "1000", key: "yszzbsyz2", title: "试样重", category: 6, type: 3 },
  cell_60_p06: { unit: "g", valType: "input", resultValue: "", key: "1yszzbzl2", title: "压碎后的筛余质量", category: 6, type: 3 },
  cell_60_p07: { unit: "g", valType: "calc", resultValue: "", key: "yszb2", title: "压碎指标", category: 6, type: 3 },
  cell_60_p08: { unit: "g", valType: "input", resultValue: "1000", key: "yszzbsyz3", title: "试样重", category: 6, type: 3 },
  cell_60_p09: { unit: "g", valType: "input", resultValue: "", key: "yszzbzl3", title: "压碎后的筛余质量", category: 6, type: 3 },
  cell_60_p10: { unit: "g", valType: "calc", resultValue: "", key: "yszb3", title: "压碎指标", category: 6, type: 3 },
  cell_60_p11: { unit: "g", valType: "input", resultValue: "1000", key: "yszzbsyz4", title: "试样重", category: 6, type: 3 },
  cell_60_p12: { unit: "g", valType: "input", resultValue: "", key: "yszzbzl4", title: "压碎后的筛余质量", category: 6, type: 3 },
  cell_60_p13: { unit: "g", valType: "calc", resultValue: "", key: "yszb4", title: "压碎指标", category: 6, type: 3 },
  // 以下为计算属性
  cell_24: { resultValue: "", key: "ljhl10", title: "10.0mm以上粒径含量", category: 6, type: 3 },
  cell_28: { resultValue: "", key: "cell_28", title: "堆积密度值", category: 6, type: 3 },
  cell_32: { resultValue: "", key: "djmd2", title: "堆积密度值", category: 6, type: 3 },
  cell_33: { resultValue: "", key: "djmd", title: "堆积平均值", category: 1, type: 3 },
  cell_37: { resultValue: "", key: "bgmd1", title: "表观密度值", category: 6, type: 3 },
  cell_41: { resultValue: "", key: "bgmd2", title: "表观密度值", category: 6, type: 3 },
  cell_42: { resultValue: "", key: "bgmd", title: "表观平均值", category: 1, type: 3 },
  cell_136: { resultValue: "", key: "kxl", title: "空隙率", category: 6, type: 3 },
  cell_45: { resultValue: "", key: "hnl1", title: "含泥量", category: 6, type: 3 },
  cell_48: { resultValue: "", key: "hnl2", title: "含泥量", category: 6, type: 3 },
  cell_49: { resultValue: "", key: "hnl", title: "含泥量平均值", category: 1, type: 3 },
  cell_52: { resultValue: "", key: "nkhl1", title: "泥块含量", category: 6, type: 3 },
  cell_55: { resultValue: "", key: "nkhl2", title: "泥块含量", category: 6, type: 3 },
  cell_56: { resultValue: "", key: "nkhl", title: "泥块含量平均值", category: 1, type: 3 },
  cell_59: { resultValue: "", key: "yjlsycdz", title: "亚甲蓝试验测定值", category: 6, type: 3, clsObj: { bg1: true } },
  // cell_60_p01: {resultValue: '', options: '', title: '试样重', category: 6, type: 3},
  // cell_60_p02: {resultValue: '', options: '', title: '压碎后的筛余质量', category: 6, type: 3},
  // cell_60_p03: {resultValue: '', options: '', title: '压碎指标', category: 6, type: 3},
  // cell_60_p04: {resultValue: '', options: '', title: '总压碎值指标', category: 6, type: 3},
  // cell_60_p05: {resultValue: '', options: '', title: '试样重', category: 6, type: 3},
  // cell_60_p06: {resultValue: '', options: '', title: '压碎后的筛余质量', category: 6, type: 3},
  // cell_60_p07: {resultValue: '', options: '', title: '压碎指标', category: 6, type: 3},
  // cell_60_p08: {resultValue: '', options: '', title: '试样重', category: 6, type: 3},
  // cell_60_p09: {resultValue: '', options: '', title: '压碎后的筛余质量', category: 6, type: 3},
  // cell_60_p10: {resultValue: '', options: '', title: '压碎指标', category: 6, type: 3},
  // cell_60_p11: {resultValue: '', options: '', title: '试样重', category: 6, type: 3},
  // cell_60_p12: {resultValue: '', options: '', title: '压碎后的筛余质量', category: 6, type: 3},
  // cell_60_p13: {resultValue: '', options: '', title: '压碎指标', category: 6, type: 3},
  cell_127: { resultValue: "", key: "uf1", title: "uf1", category: 6, type: 3 },
  cell_128: { resultValue: "", key: "uf2", title: "uf2", category: 6, type: 3 },
  cell_129: { resultValue: "", key: "xdmspjz", title: "细度模数平均值", category: 1, type: 3 },
  cell_130: { resultValue: "", key: "uf1_uf2", title: "uf1-uf2", category: 6, type: 3 },
  cell_131: { resultValue: "", key: "hsl1", title: "含石量", category: 6, type: 3 },
  cell_132: { resultValue: "", key: "hsl2", title: "含石量", category: 6, type: 3 },
  cell_133: { resultValue: "", key: "hsl", title: "含石量", category: 1, type: 3 },
  cell_64: { resultValue: "", key: "fjsybfl1_1", title: "分计筛余百分率", category: 1, type: 3 },
  cell_65: { resultValue: "", key: "ljsybfl1_1", title: "累计筛余百分率", category: 1, type: 3 },
  cell_67: { resultValue: "", key: "fjsybfl2_1", title: "分计筛余百分率", category: 1, type: 3 },
  cell_68: { resultValue: "", key: "ljsybfl2_1", title: "累计筛余百分率", category: 1, type: 3 },
  cell_69: { resultValue: "", key: "fjsybflpjz1", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_70: { resultValue: "", key: "ljsybflpjz1", title: "累计筛余百分率平均值", category: 6, type: 3 },
  cell_72: { resultValue: "", key: "fjsybfl1_2", title: "分计筛余百分率", category: 6, type: 3 },
  cell_73: { resultValue: "", key: "ljsybfl1_2", title: "累计筛余百分率", category: 6, type: 3 },
  cell_75: { resultValue: "", key: "fjsybfl2_2", title: "分计筛余百分率", category: 6, type: 3 },
  cell_76: { resultValue: "", key: "ljsybfl2_2", title: "累计筛余百分率", category: 6, type: 3 },
  cell_77: { resultValue: "", key: "fjsybflpjz2", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_78: { resultValue: "", key: "ljsybflpjz2", title: "累计筛余百分率平均值", category: 6, type: 3 },
  cell_80: { resultValue: "", key: "fjsybfl1_3", title: "分计筛余百分率", category: 6, type: 3 },
  cell_81: { resultValue: "", key: "ljsybfl1_3", title: "累计筛余百分率", category: 6, type: 3 },
  cell_83: { resultValue: "", key: "fjsybfl2_3", title: "分计筛余百分率", category: 6, type: 3 },
  cell_84: { resultValue: "", key: "ljsybfl2_3", title: "累计筛余百分率", category: 6, type: 3 },
  cell_85: { resultValue: "", key: "fjsybflpjz3", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_86: { resultValue: "", key: "ljsybflpjz3", title: "累计筛余百分率平均值", category: 6, type: 3 },
  cell_88: { resultValue: "", key: "fjsybfl1_4", title: "分计筛余百分率", category: 6, type: 3 },
  cell_89: { resultValue: "", key: "ljsybfl1_4", title: "累计筛余百分率", category: 6, type: 3 },
  cell_91: { resultValue: "", key: "fjsybfl2_4", title: "分计筛余百分率", category: 6, type: 3 },
  cell_92: { resultValue: "", key: "ljsybfl2_4", title: "累计筛余百分率", category: 6, type: 3 },
  cell_93: { resultValue: "", key: "fjsybflpjz4", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_94: { resultValue: "", key: "ljsybflpjz4", title: "累计筛余百分率平均值", category: 6, type: 3 },
  cell_96: { resultValue: "", key: "fjsybfl1_5", title: "分计筛余百分率", category: 6, type: 3 },
  cell_97: { resultValue: "", key: "ljsybfl1_5", title: "累计筛余百分率", category: 6, type: 3 },
  cell_99: { resultValue: "", key: "fjsybfl2_5", title: "分计筛余百分率", category: 6, type: 3 },
  cell_100: { resultValue: "", key: "ljsybfl2_5", title: "累计筛余百分率", category: 6, type: 3 },
  cell_101: { resultValue: "", key: "fjsybflpjz5", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_102: { resultValue: "", key: "ljsybflpjz5", title: "累计筛余百分率平均值", category: 6, type: 3 },
  cell_104: { resultValue: "", key: "fjsybfl1_6", title: "分计筛余百分率", category: 6, type: 3 },
  cell_105: { resultValue: "", key: "ljsybfl1_6", title: "累计筛余百分率", category: 6, type: 3 },
  cell_107: { resultValue: "", key: "fjsybfl2_6", title: "分计筛余百分率", category: 6, type: 3 },
  cell_108: { resultValue: "", key: "ljsybfl2_6", title: "累计筛余百分率", category: 6, type: 3 },
  cell_109: { resultValue: "", key: "fjsybflpjz6", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_110: { resultValue: "", key: "ljsybflpjz6", title: "累计筛余百分率平均值", category: 6, type: 3 },
  cell_112: { resultValue: "", key: "fjsybfl1_7", title: "分计筛余百分率", category: 6, type: 3 },
  cell_113: { resultValue: "", key: "ljsybfl1_7", title: "累计筛余百分率", category: 6, type: 3 },
  cell_115: { resultValue: "", key: "fjsybfl2_7", title: "分计筛余百分率", category: 6, type: 3 },
  cell_116: { resultValue: "", key: "ljsybfl2_7", title: "累计筛余百分率", category: 6, type: 3 },
  cell_117: { resultValue: "", key: "fjsybflpjz7", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_118: { resultValue: "", key: "ljsybflpjz7", title: "累计筛余百分率平均值", category: 6, type: 3 },
  cell_120: { resultValue: "", key: "fjsybfl1_8", title: "分计筛余百分率", category: 6, type: 3 },
  cell_121: { resultValue: "", key: "ljsybfl1_8", title: "累计筛余百分率", category: 6, type: 3 },
  cell_123: { resultValue: "", key: "fjsybfl2_8", title: "分计筛余百分率", category: 6, type: 3 },
  cell_124: { resultValue: "", key: "ljsybfl2_8", title: "累计筛余百分率", category: 6, type: 3 },
  cell_125: { resultValue: "", key: "fjsybflpjz8", title: "分计筛余百分率平均值", category: 6, type: 3 },
  cell_126: { resultValue: "", key: "ljsybflpjz8", title: "累计筛余百分率平均值", category: 6, type: 3 },
};
export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
    };
  },
  created() {
    console.log(dataArr)
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }else {
              if (item.isQualified === 0) {
                item.clsObj = {
                  "red-bg": true
                }
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj = {
                  "yellow-bg": true
                }
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      if(form.cell_13 && form.cell_13.resultValue && !this.calcObject(form.cell_13.resultValue)) {
        form.cell_13.resultValue = JSON.parse(form.cell_13.resultValue)
      }
      if(form.cell_17 && form.cell_17.resultValue && !this.calcObject(form.cell_17.resultValue)) {
        form.cell_17.resultValue = JSON.parse(form.cell_17.resultValue)
      }
      if(form.cell_19 && form.cell_19.resultValue && !this.calcObject(form.cell_19.resultValue)) {
        form.cell_19.resultValue = JSON.parse(form.cell_19.resultValue)
      }
      this.formData = form;
    }
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(JSON.stringify(item.resultValue));
      }
    }
  },
  mounted() {
    // if (Object.keys(this.saveData).length === 0) {
    //   this.formData = JSON.parse(JSON.stringify(dataArr));
    // } else {
    //   let form = JSON.parse(JSON.stringify(this.saveData));
    //   for (let key in dataArr) {
    //     let item = form[key];
    //     if (!item) {
    //       item = dataArr[key];
    //       if (this.isViewResult) {
    //         // 查看，设置查看效果
    //         if (item.clsObj) {
    //           for (let i in item.clsObj) {
    //             item.clsObj[i] = false;
    //           }
    //           if (item.isQualified === 0) {
    //             item.clsObj["red-bg"] = true;
    //           } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
    //             item.clsObj["yellow-bg"] = true;
    //           }
    //         }
    //       }
    //     }
    //   }
    //   if(form.cell_13 && form.cell_13.resultValue && !this.calcObject(form.cell_13.resultValue)) {
    //     form.cell_13.resultValue = JSON.parse(form.cell_13.resultValue)
    //   }
    //   if(form.cell_17 && form.cell_17.resultValue && !this.calcObject(form.cell_17.resultValue)) {
    //     form.cell_17.resultValue = JSON.parse(form.cell_17.resultValue)
    //   }
    //   if(form.cell_19 && form.cell_19.resultValue && !this.calcObject(form.cell_19.resultValue)) {
    //     form.cell_19.resultValue = JSON.parse(form.cell_19.resultValue)
    //   }
    //   this.formData = form;
    // }
    // for (const key in this.formData) {
    //   let item = this.formData[key];
    //   if (item.options && item.resultValue && typeof item.resultValue === "string") {
    //     console.log(item);
    //     item.resultValue = JSON.parse(JSON.stringify(item.resultValue));
    //   }
    // }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    console.log(this.defaultData.content);
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges(a, b) {
      this.$nextTick(() => {
              // 有输入就核算
      console.log(a, b);
      let val = "";
      // 10mm以上粒径含量
      if (this.hasValues([22, 23])) {
        console.log("aaaaaa");
        val = Math.round((this.getFieldVal(23) / this.getFieldVal(22)) * 100);
      }
      console.log(val);
      this.setFieldVal(24, val);

      // 堆积密度
      this.formData["cell_28"].resultValue = this.calcDJMD(25, 26, 27);
      this.formData["cell_32"].resultValue = this.calcDJMD(29, 30, 31);
      this.formData["cell_33"].resultValue = this.calcAverage(28, 32);

      // 表观密度
      this.formData["cell_37"].resultValue = this.calcBGMD(34, 35, 36);
      this.formData["cell_41"].resultValue = this.calcBGMD(38, 39, 40);
      this.formData["cell_42"].resultValue = this.calcAverage(37, 41);

      // 含泥量
      this.formData["cell_45"].resultValue = this.calcHNL(43, 44);
      this.formData["cell_48"].resultValue = this.calcHNL(46, 47);
      this.formData["cell_49"].resultValue = this.calcHNLAverage(45, 48);

      // 泥块含量
      this.formData["cell_52"].resultValue = this.calcHNL(50, 51);
      this.formData["cell_55"].resultValue = this.calcHNL(53, 54);
      this.formData["cell_56"].resultValue = this.calcHNLAverage(52, 55);
      // 亚甲蓝实验，测定值
      this.formData["cell_59"].resultValue = this.calcYJL(57, 58);
      // 计算实验数据
      this.calcTest();
      })
    },
    hasValues(indexArr) {
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!this.formData[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (this.formData[key].resultValue === undefined || this.formData[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    // 计算是否为对象
    calcObject(num) {
      if(Object.prototype.toString.call(num) === '[object Object]') {
        return true
      }else {
        return false
      }
    },
    // 计算堆积密度值
    calcDJMD(x, y, z) {
      let res = "";
      if (this.hasValues([x, y, z])) {
        let xVal = this.formData["cell_" + x].resultValue,
          yVal = this.formData["cell_" + y].resultValue,
          zVal = this.formData["cell_" + z].resultValue;
        res = Math.round((xVal - yVal) / zVal / 10, 0) * 10;
      }
      return res;
    },
    // 计算表观密度值
    calcBGMD(x, y, z) {
      let res = "";
      if (this.hasValues([x, y, z])) {
        let xVal = this.formData["cell_" + x].resultValue,
        yVal = this.formData["cell_" + y].resultValue,
        zVal = this.formData["cell_" + z].resultValue;
        res = ((xVal*1 / (xVal*1 + yVal*1 - zVal*1)).toFixed(2))*1000
      }
      return res;
    },
    // 计算含泥量
    calcHNL(x, y) {
      let res = "";
      if (this.hasValues([x, y])) {
        let xVal = this.formData["cell_" + x].resultValue,
          yVal = this.formData["cell_" + y].resultValue;
        res = (((xVal - yVal) / xVal) * 100).toFixed(1);
      }

      return res;
    },
    // 计算亚甲蓝
    calcYJL(x, y) {
      let res = "";
      if (this.hasValues([x, y])) {
        let xVal = this.formData["cell_" + x].resultValue,
          yVal = this.formData["cell_" + y].resultValue;
        // =C29/B29*10
        res = (yVal / xVal) * 10;
      }

      return res;
    },
    // 计算平均值
    calcAverage(x, y) {
      let res = "";
      if (this.hasValues([x, y])) {
        // 计算
        let xVal = this.formData["cell_" + x].resultValue * 1,
          yVal = this.formData["cell_" + y].resultValue * 1;
        if (Math.floor((xVal + yVal) / 2 / 10) % 2 === 0) {
          if ((Math.floor((xVal + yVal) / 2) + 5) % 10 === 0) {
            if ((xVal + yVal) / 2 - Math.floor((xVal + yVal) / 2) === 0) {
              res = Math.floor((xVal + yVal) / 2 / 10) * 10;
            } else {
              res = Math.round((xVal + yVal) / 2 / 10, 0) * 10;
            }
          } else {
            res = Math.round((xVal + yVal) / 2 / 10, 0) * 10;
          }
        } else {
          res = Math.round((xVal + yVal) / 2 / 10, 0) * 10;
        }
      }

      return res;
    },
    // 泥块含量的平均值
    calcHNLAverage(x, y) {
      let res = "";
      if (this.hasValues([x, y])) {
        // 计算
        let xVal = this.formData["cell_" + x].resultValue * 1,
          yVal = this.formData["cell_" + y].resultValue * 1;
        if (Math.floor(((xVal + yVal) / 2) * 10) % 2 === 0) {
          if ((Math.floor(((xVal + yVal) / 2) * 100) + 5) % 10 === 0) {
            if ((xVal + yVal) / 2 - Math.floor(((xVal + yVal) / 2) * 100) / 100 === 0) {
              res = (((xVal + yVal) / 2 / 10) * 10).toFixed(1);
            } else {
              res = ((xVal + yVal) / 2).toFixed(1);
            }
          } else {
            res = ((xVal + yVal) / 2).toFixed(1);
          }
        } else {
          res = ((xVal + yVal) / 2).toFixed(1);
        }
      }

      return res;
    },
    calcTest() {
      let pre;
      pre = this.calcTestGroup(63, 64, 65, pre);
      pre = this.calcTestGroup(71, 72, 73, pre);
      pre = this.calcTestGroup(79, 80, 81, pre);
      pre = this.calcTestGroup(87, 88, 89, pre);
      pre = this.calcTestGroup(95, 96, 97, pre);
      pre = this.calcTestGroup(103, 104, 105, pre);
      pre = this.calcTestGroup(111, 112, 113, pre);
      pre = this.calcTestGroup(119, 120, 121, pre);
      pre = undefined;
      pre = this.calcTestGroup(66, 67, 68, pre);
      pre = this.calcTestGroup(74, 75, 76, pre);
      pre = this.calcTestGroup(82, 83, 84, pre);
      pre = this.calcTestGroup(90, 91, 92, pre);
      pre = this.calcTestGroup(98, 99, 100, pre);
      pre = this.calcTestGroup(106, 107, 108, pre);
      pre = this.calcTestGroup(114, 115, 116, pre);
      pre = this.calcTestGroup(122, 123, 124, pre);
      pre = undefined;
      pre = this.calcTestGroup4Average(64, 67, 69, 70, pre);
      pre = this.calcTestGroup4Average(72, 75, 77, 78, 70);
      pre = this.calcTestGroup4Average(80, 83, 85, 86, 78);
      pre = this.calcTestGroup4Average(88, 91, 93, 94, 86);
      pre = this.calcTestGroup4Average(96, 99, 101, 102, 94);
      pre = this.calcTestGroup4Average(104, 107, 109, 110, 102);
      pre = this.calcTestGroup4Average(112, 115, 117, 118, 110);
      pre = this.calcTestGroup4Average(120, 123, 125, 126, 118);
      //细度模数平均值 =(O19+O20+O21+O22+O23-5*O18)/(100-O18)
      setTimeout(() => {
        pre = (
        ((this.getFieldVal(86) || 0) + (this.getFieldVal(94) || 0) + (this.getFieldVal(102) || 0) + (this.getFieldVal(110) || 0) + (this.getFieldVal(118) || 0) - (this.getFieldVal(78) || 0) * 5) /
        (100 - (this.getFieldVal(70) || 0))
      ).toFixed(1);
      this.setFieldVal(129, pre);
      }, 20);
      
      //含石量
      this.setFieldVal(131, this.getFieldVal(72) || 0);
      this.setFieldVal(132, this.getFieldVal(75) || 0);
      pre = (((this.getFieldVal(131) || 0) + (this.getFieldVal(132) || 0)) / 2).toFixed(1);
      this.setFieldVal(133, pre);
      // 细度模数
      this.setFieldVal2(
        127,
        (
          ((this.getFieldVal(81) || 0) + (this.getFieldVal(89) || 0) + (this.getFieldVal(97) || 0) + (this.getFieldVal(105) || 0) + (this.getFieldVal(113) || 0) - (this.getFieldVal(73) || 0) * 5) /
          (100 - (this.getFieldVal(73) || 0))
        ).toFixed(2)
      );
      this.setFieldVal(
        128,
        (
          ((this.getFieldVal(84) || 0) + (this.getFieldVal(92) || 0) + (this.getFieldVal(100) || 0) + (this.getFieldVal(108) || 0) + (this.getFieldVal(116) || 0) - (this.getFieldVal(76) || 0) * 5) /
          (100 - (this.getFieldVal(76) || 0))
        ).toFixed(2)
      );
      console.log(this.getFieldVal(127) || 0, this.getFieldVal(128) || 0);
      this.setFieldVal2(130, (this.getFieldVal(127) || 0) - (this.getFieldVal(128) || 0));
      //级配判定
      const cumulative = []; //累计筛余百分率
      cumulative[0] = [this.getFieldVal(65) || 0, this.getFieldVal(73) || 0, this.getFieldVal(81) || 0, this.getFieldVal(89) || 0, this.getFieldVal(97) || 0, this.getFieldVal(105) || 0, this.getFieldVal(113) || 0];
      cumulative[1] = [this.getFieldVal(68) || 0, this.getFieldVal(76) || 0, this.getFieldVal(84) || 0, this.getFieldVal(92) || 0, this.getFieldVal(100) || 0, this.getFieldVal(108) || 0, this.getFieldVal(116) || 0];
      this.setFieldVal(134, this.qualifiedVerification(cumulative) ? "合格" : "不合格");
    },
    calcTestGroup(x, y, z, pre) {
      let res = 0;
      if (this.hasValues([x])) {
        let xVal = this.getFieldVal(x);
        res = (xVal * 0.2).toFixed(1) * 1;
        this.setFieldVal(y, res);
        res = (res + (pre ? pre : 0)).toFixed(1) * 1;
        this.setFieldVal(z, res);
      } else {
        this.setFieldVal(y, "");
        this.setFieldVal(z, "");
      }

      return res;
    },
    calcTestGroup4Average(x1, x2, y, z, pre) {
      this.$nextTick(() => {
        let res = 0;
      if (this.hasValues([x1, x2])) {
        let x1Val = this.getFieldVal(x1);
        let x2Val = this.getFieldVal(x2);
        res = ((x1Val + x2Val) / 2).toFixed(1) * 1;
        this.setFieldVal(y, res);
        let preValue =0;
        if(pre) {
          preValue = this.getFieldVal(pre)
        }
        res = res +preValue;
        this.setFieldVal(z, res.toFixed(0));
      } else {
        this.setFieldVal(y, "");
        this.setFieldVal(z, "");
      }
      return res;
      })
       
    },
    //合格校验
    qualifiedVerification(cumulative) {
      for (let i = 1; i < cumulative[0].length; i++) {
        const avg = (cumulative[0][i] + cumulative[1][i]) / 2;
        switch (i) {
          case 1: //4.75mm
            //必须满足
            if (!this.checkScope(avg, 10, 0, true)) {
              return false;
            }
            break;
          case 2: //2.36mm
            if (!this.checkScope(avg, 25, 0)) {
              return false;
            }
            break;
          case 3: //1.18mm
            if (!this.checkScope(avg, 50, 10)) {
              return false;
            }
            break;
          case 4: //600µm
            //必须满足
            if (!this.checkScope(avg, 70, 41, true)) {
              return false;
            }
            break;
          case 5: //300µm
            if (!this.checkScope(avg, 92, 70)) {
              return false;
            }
            break;
          case 6: //150µm
            if (!this.checkScope(avg, 100, 90)) {
              return false;
            }
            break;
        }
      }
      return true;
    },
    checkScope(value, max, min, compulsory = false) {
      let qualified = true;
      if (value > max || value < min) {
        qualified = false;
        if (!compulsory) {
          // 非强制校验可超过5
          if (max - value <= 5 || value - min >= 5) {
            qualified = true;
          }
        }
      }
      return qualified;
    },
    getFieldVal(x) {
      return this.formData["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.$nextTick(() => {
        this.$set(this.formData["cell_" + x],'resultValue',val)
      })
    },
    setFieldVal2(x, val) {
      this.$nextTick(() => {
        this.$set(this.formData["cell_" + x],'resultValue',(val*1).toFixed(2))
      })
    },
    setData() {
      let config = {
        form: {
          cell_60_p01: this.formData.cell_60_p01,
          cell_60_p02: this.formData.cell_60_p02,
          cell_60_p03: this.formData.cell_60_p03,
          // cell_60_p04: this.formData.cell_60_p04,
          cell_60_p05: this.formData.cell_60_p05,
          cell_60_p06: this.formData.cell_60_p06,
          cell_60_p07: this.formData.cell_60_p07,
          cell_60_p08: this.formData.cell_60_p08,
          cell_60_p09: this.formData.cell_60_p09,
          cell_60_p10: this.formData.cell_60_p10,
          cell_60_p11: this.formData.cell_60_p11,
          cell_60_p12: this.formData.cell_60_p12,
          cell_60_p13: this.formData.cell_60_p13,
        },
      };
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      this.calcC60(form, "cell_60_p01", "cell_60_p02", "cell_60_p03");
      this.calcC60(form, "cell_60_p05", "cell_60_p06", "cell_60_p07");
      this.calcC60(form, "cell_60_p08", "cell_60_p09", "cell_60_p10");
      this.calcC60(form, "cell_60_p11", "cell_60_p12", "cell_60_p13");
      // 改为取压碎指标最大值
      this.formData["cell_60_p04"].resultValue = Math.max(form["cell_60_p03"].resultValue,form["cell_60_p07"].resultValue,form["cell_60_p10"].resultValue,form["cell_60_p13"].resultValue)
      // （a1b1+a2b2+a3b3+a4b4）/(a1+a2+a3+a4)*100%）
      // this.formData["cell_60_p04"].resultValue = Math.round(
      //   ((form["cell_60_p02"].resultValue * form["cell_60_p03"].resultValue +
      //     form["cell_60_p06"].resultValue * form["cell_60_p07"].resultValue +
      //     form["cell_60_p09"].resultValue * form["cell_60_p10"].resultValue +
      //     form["cell_60_p12"].resultValue * form["cell_60_p13"].resultValue) /
      //     (form["cell_60_p02"].resultValue + form["cell_60_p06"].resultValue + form["cell_60_p09"].resultValue + form["cell_60_p12"].resultValue)) *
      //     100
      // );
    },
    calcC60(form, x, y, z) {
      form[x].resultValue = Math.round(form[x].resultValue || 0) * 1;
      form[y].resultValue = Math.round(form[y].resultValue || 0) * 1;
      form[z].resultValue = Math.round(((form[x].resultValue - form[y].resultValue) / form[x].resultValue) * 100);
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      this.formData.cell_13.type = 1
      this.formData.cell_17.type = 1
      this.formData.cell_19.type = 1
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>

<style lang="scss">
#template1 {
  width: 1200px;
}

.notQuality {
  background: red;
  color: #fff;
}
.bgColor {
  // 相邻波动
  background: orange;
  color: #fff;
}
.red { // 配置项颜色
    color: red;
    cursor: pointer;
}
.red-bg {
    background: red;
    color: #000;
}
</style>
